import script from "./AnswerResultView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnswerResultView.vue?vue&type=script&setup=true&lang=ts"

import "./AnswerResultView.vue?vue&type=style&index=0&id=7ac60cb8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ac60cb8"]])

export default __exports__